<template>
  <FwbCard class="card-content rounded-none">
    <div class="card-title">{{ props.resource.title }}</div>
    <div class="card-description">{{ props.resource.description }}</div>
    <div class="card-access-button">
      <button class="action-button" @click="onAccessClicked">Access</button>
    </div>
  </FwbCard>
</template>

<script setup>
import { FwbCard } from 'flowbite-vue';
import { defineProps, defineEmits } from 'vue';
import apiManager from '@/api';
import { openFile } from '@/utils/blobOptions';

const emits = defineEmits(['isDownloading', 'isDownloadComplete']);

const props = defineProps({
  resource: {
    type: Object,
    required: true,
  },
});

function onDownloadFile() {
  emits('isDownloading');
  apiManager.dashboardResouce.Download(props.resource.id)
    .then((data) => {
      if (data) {
        openFile(props.resource.fileName, data);
      }
    })
    .finally(() => {
      emits('isDownloadComplete');
    });
}

function onLinkClicked() {
  const link = document.createElement('a');
  link.href = props.resource.linkURL;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  link.click();
  document.body.removeChild(link);
}

function onAccessClicked() {
  if (props.resource.resourceType === 'Document') {
    apiManager.analytic.add({ analyticTypeName: 'ResourceDocument', analyticSource: props.resource.title });
    onDownloadFile();
  } else {
    apiManager.analytic.add({ analyticTypeName: 'ResourceLink', analyticSource: props.resource.title });
    onLinkClicked();
  }
}
</script>

<style scoped>
  .card-content {
    min-width:400px;
    min-height: 240px;
    max-height: 240px;
    flex: 1;
    margin: 10px;
    padding: 15px;
  }

  .card-title {
    font-size: 1.8rem;
    top: 0px
  }

  .card-description {
    margin-top: 5px;
    height: 100px;
    overflow-y: auto;
  }

  .card-access-button {
    margin-top:15px;
  }

  .action-button {
    width: 80px;
    height: 40px;
  }

  @media (max-width: 430px) {
    .card-content {
      min-width:350px;
    }

    .action-button {
      width: 100%;
      height: 40px;
    }
  }

  @media (max-width: 400px) {
    .card-content {
      min-width:300px;
    }
  }

  @media (max-width: 360px) {
    .card-content {
      min-width:280px;
    }
  }
</style>
